export default "__VITE_ASSET__30a0c378__$_?nuxt_component=async&nuxt_component_name=SvgoFlokigames__"